module.exports = __webpack_public_path__ + "img/dianshiji.44892864.png";